const corePageContent = {
  '/': {
    hero: {
      title: '揺腕法',
      subtitle: '腕を振るだけで身体が整う',
    },
    overview: {
      title: '揺腕法とは何でしょう？',
      leadSentence:
        '揺腕法は「ボディワーク 刀禅」の創始者・小用茂夫（Shigeo Koyou）が発表した、新しい身体運動法です。',
      paragraphs: [
        'その特色は、「腕を振る」という極シンプルな運動を通じて、身体の基準性である垂直性・水平性を整えることで、すべての運動の出発点となる自分の身体を再構築することにあります。',
        'パソコンの OS をバージョンアップすることで、その上で動いているアプリケーション全体をより快適に使えるようにするようなイメージで、日常動作からスポーツまでの質を底から整えていきます。',
        '歩く、立つ、起き上がる、物を取るといった動作から、武術的身体の基準づくりまでを一つの連続として見直すための入口です。',
      ],
    },
    highlights: {
      title: '最初に見てほしい導線',
      cards: [
        {
          title: '創始者紹介',
          body: '揺腕法がどのような背景と思想から生まれたのかを、最初に理解したい方へ。',
          href: '/founder',
          ctaLabel: '創始者を知る',
        },
        {
          title: 'ご感想',
          body: '体験した方の言葉から、揺腕法による変化の輪郭をつかみたい方へ。',
          href: '/reviews',
          ctaLabel: '感想を読む',
        },
        {
          title: '教室・講座情報',
          body: '定期教室とセミナーの両方を見渡しながら、参加の入口を探したい方へ。',
          href: '/classes',
          ctaLabel: '講座を見る',
        },
        {
          title: 'ブログ',
          body: '揺腕法にまつわる発信や今後の読み物を、一覧として追っていきたい方へ。',
          href: '/blog',
          ctaLabel: 'ブログを見る',
        },
      ],
    },
    updates: {
      title: '最新情報',
      cards: [
        {
          title: '書籍『揺腕法』発売決定！',
          body: '2024年2月15日に、待望の入門書『〝謎の老師〟が教える身体の基準の創り方 揺腕法』が日貿出版社より刊行されました。揺腕の基本だけでなく、身体の基準性や中動態、そしてなぜ「腕を振るだけ」にこだわるのかまでが書かれています。',
          href: 'https://www.amazon.co.jp/',
          ctaLabel: 'アマゾンへ',
          external: true,
        },
      ],
    },
    blogPreview: {
      items: [
        { date: '2026.04.01', title: 'ブログ記事タイトルがここに入ります', href: '/blog' },
        { date: '2026.03.28', title: 'ブログ記事タイトルがここに入ります', href: '/blog' },
        { date: '2026.03.21', title: 'ブログ記事タイトルがここに入ります', href: '/blog' },
        { date: '2026.03.14', title: 'ブログ記事タイトルがここに入ります', href: '/blog' },
        { date: '2026.03.07', title: 'ブログ記事タイトルがここに入ります', href: '/blog' },
      ],
    },
    schedule: {
      title: '講座予定',
      lead:
        '現在決まっている講座情報をご紹介しています。詳しい情報は',
      linkLabel: '「講座情報」',
      href: '/classes',
      bridge: 'からご覧ください。',
      tail:
        '月間の予定は Google カレンダーでご確認いただけます。',
      cards: [],
      calendarTitle: '揺腕法 講座予定 Google カレンダー',
      calendarFallbackLabel: 'Google カレンダーは現在準備中です。',
    },
    contact: {
      title: 'お問い合わせ',
      paragraphs: [
        '揺腕の内容や講座情報、地方出張や個人レッスンのお申し込み、取材などのお問い合わせはこちらからお願いします。',
      ],
      cards: [
        {
          title: 'お問い合わせ',
          body: '講座内容、地方出張、個人レッスン、取材などの相談はこちらからご確認ください。',
          href: '/contact',
          ctaLabel: 'お問い合わせへ',
        },
      ],
    },
  },
  '/founder': {
    profile: {
      eyebrow: '創始者',
      title: '小用茂夫',
      roman: '(Shigeo Koyou)',
      portraitLabel: 'portrait area',
      bio:
        '略歴：1950年埼玉県出身。刀禅創始者。新陰流、形意拳、大東流などの武道・武術を研鑽。独自の稽古会を重ねて、2010年からボディワーク刀禅として公開。女性を中心とした舞扇道を考案。現在、埼玉県蕨市を拠点として活動。稽古会は埼玉県、東京都、神奈川県、愛知県、大阪府、岡山県、広島県、福岡県に同好会がある。',
      links: [
        {
          label: 'Facebook',
          href: 'https://www.facebook.com/bodywork.touzen/',
          external: true,
        },
        {
          label: 'X',
          href: 'https://twitter.com/touzen__',
          external: true,
        },
      ],
    },
    touzen: {
      title: '刀禅とは？',
      subtitle: '武術から生まれたボディワーク',
      paragraphs: [
        '刀禅は創始者・小用茂夫が、多年にわたって学んだ武道・武術から、最も重要なエッセンスを「身体の基準性」として抽出し、合理的な稽古体系にまとめた日本発のボディワークです。',
        'その特徴は個人の才能や環境に関係なく、シンプルな稽古を繰り返すことで、誰もが持続的に成長できる稽古システムにあります。',
      ],
      officialLink: {
        label: '公式サイト',
        href: 'https://www.touzen.jp/',
        external: true,
      },
      logoLabel: 'touzen logo area',
    },
  },
  '/classes': {
    hero: {
      title: '教室・講座',
      lead:
        'ここでは、揺腕の教室＆講座情報を紹介しています。すべてのクラスは直伝稽古を除き、揺腕公認インストラクターによって指導されます。',
    },
    intro: {
      lead:
        'お気軽にご参加ください。',
      supportPrefix: '過去の講座の',
      supportLabel: 'ご感想はこちら',
      supportHref: '/reviews',
      supportSuffix: 'からどうぞ。',
    },
    classes: {
      title: '常設クラス',
      lead:
        '地域ごとに継続参加できる教室です。継続的に参加できる拠点をまとめています。',
      cards: [],
    },
    seminars: {
      title: 'セミナー・体験会',
      lead:
        '開催回ごとに内容や地域が変わるセミナー・体験会です。揺腕法の基本から刀禅とのつながりまでを一緒に体験できます。',
      cards: [],
    },
  },
};

module.exports = corePageContent;
module.exports.corePageContent = corePageContent;
